import { ESearchWizardSteps } from "../../shared/enums/search.enums";
import {
  IAcceptOutageValues,
  IFormValues,
  IOutageSearchProps,
  ISearchFormValues,
} from "./Form.types";

const phoneRegExp =
  /^\(?([2-9][0-8][0-9])\)?[-. ]?([2-9][0-9]{2})[-. ]?([0-9]{4})$/;
// /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;

const nameRegExp = /^[a-zA-Z\s]*$/;

const commentsRegExp =
  /^[^\p{Extended_Pictographic}\u{1F3FB}-\u{1F3FF}\u{1F9B0}-\u{1F9B3}]*$/gu;

const FeedbackMessages = {
  additionalDetailsMax: "Cannot exceed 190 characters",
  nameMin: "Name must be at least 6 characters",
  nameMax: "Name cannot exceed 20 characters",
  nameMatch: "Name cannot contain special characters",
  nameRequired: "Name is required",
  phoneMax: "Phone number cannot exceed 12 characters",
  phoneMatch: "Area code and exchange cannot begin with '1'",
  phoneRequired: "Phone number is required",
  emailMax: "Email cannot exceed 60 characters",
  emailMatch: "Email addresses should be in the form user@email.com",
  emailRequired: "Email address is required",
  dropdownOptionRequired: "Please select the nature of your outage",
  bracketTypeRequired: "Light style selection required",
  searchTextRequired: "This is a required field",
  adminGisIdRequired: "GISID is required",
  emojisRestricted: "Emoji(s) are not allowed. Please remove and try again",
};

const InitialValues: IFormValues = {
  outageFormDropdown: "",
  outageFormComments: "",
  outageFormName: "",
  outageFormPhone: "",
  outageFormEmail: "",
  outageFormBracketType: "",
};

const InitialSearchValues: ISearchFormValues = {
  searchFormText: "",
};

const InitialAcceptOutageValues: IAcceptOutageValues = {
  acceptOutageFormGISID: undefined,
};

export default {
  FeedbackMessages,
  InitialValues,
  InitialSearchValues,
  InitialAcceptOutageValues,
  phoneRegExp,
  nameRegExp,
  commentsRegExp,
};
